__turbopack_context__.v({
  "categories": "StartingRates-module-scss-module__hYhJEG__categories",
  "categoryRow": "StartingRates-module-scss-module__hYhJEG__categoryRow",
  "descriptionCard": "StartingRates-module-scss-module__hYhJEG__descriptionCard",
  "divider": "StartingRates-module-scss-module__hYhJEG__divider",
  "headerLabel": "StartingRates-module-scss-module__hYhJEG__headerLabel",
  "selected": "StartingRates-module-scss-module__hYhJEG__selected",
  "selectedCategoryCard": "StartingRates-module-scss-module__hYhJEG__selectedCategoryCard",
  "serviceCard": "StartingRates-module-scss-module__hYhJEG__serviceCard",
  "subtitle": "StartingRates-module-scss-module__hYhJEG__subtitle",
});
